var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"py-4 text-left truncate first:pl-4 last:pr-4 px:2",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }